// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__nhYMD","topBottomGutter":"Layout_topBottomGutter__bzGZZ"};